import styled from '@emotion/styled';
import { css } from '@emotion/react';

interface GridProps {
  grid: {
    left: number;
    top: number;
  }[];
}

export const Container = styled.div`
  display: flex;
  justify-content: center;
  width: 90%;
  height: 90%;
  gap: 60px;
  z-index: 1;
`;

export const Grid = styled.div<GridProps>`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  > div {
    position: absolute;
    width: 188.89px;
    height: 236.11px;
    z-index: -1;
    > img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  ${({ grid }) =>
    grid.map(
      (position, index) => css`
        > div:nth-of-type(${index + 1}) {
          left: ${position.left}px;
          top: ${position.top}px;
        }
      `
    )}
`;

export const FrameBox = styled.div`
  position: relative;
  width: 400px;
  height: 600px;
  margin-bottom: 12px;

  > img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    z-index: 1;
  }
`;

export const BetaBox = styled.div`
  display: flex;
  gap: 3px;
  align-items: center;

  > p {
    ${({ theme }) => theme.typography.REGULAR_12};
    color: ${({ theme }) => theme.color[2]};
  }
`;

export const Photo = styled.div<{ selected: boolean; isEmptySlot?: boolean }>`
  max-height: 350px;
  aspect-ratio: 4 / 5;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;

  background: linear-gradient(45deg, #fff, #ccc, #fff);
  background-size: 200% 200%;
  animation: gradient 3s linear infinite;
  cursor: pointer;

  ${(props) =>
    props.isEmptySlot &&
    css`
      background: ${props.theme.color[1]};
      animation: none;
      cursor: not-allowed;
      opacity: 0.5;
    `}

  > div {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: ${({ theme }) => `${theme.color[3]}80`}; // 80: 50% opacity in hex
    > div {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 80px;
      height: 80px;
      border-radius: 100%;
      background: ${({ theme }) => theme.color[4]};
      color: ${({ theme }) => theme.color[2]};
      ${({ theme }) => theme.typography.BOLD_36};
    }
    ${(props) =>
      !props.selected &&
      css`
        display: none;
      `}
  }

  @keyframes gradient {
    0% {
      background-position: 0% 50%;
    }
    50% {
      background-position: 100% 50%;
    }
    100% {
      background-position: 0% 50%;
    }
  }

  > img {
    width: 100%;
    height: 100%;
    object-fit: fill;

    &[src$='.gif'] {
      width: 60%;
      height: 60%;
      object-fit: contain;
      position: static;
    }
  }
`;

export const LoadingTextBox = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;

  > img {
    width: 28px;
    height: 28px;

    &[src$='.gif'] {
      width: 20px;
      height: 20px;
    }
  }

  > h4 {
    ${({ theme }) => theme.typography.REGULAR_30};
    color: ${({ theme }) => theme.color[2]};
    text-align: center;
  }
`;

export const PhotoList = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 10px;
  height: 350px;
  justify-items: center;
`;

export const PhotoListBox = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 240px;
  gap: 12px;

  > div {
    width: 100%;
  }
`;

export const ChooseFrameBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  > p {
    margin-top: 4px;
    text-decoration: underline;
    ${({ theme }) => theme.typography.REGULAR_12};
    color: ${({ theme }) => theme.color[2]};
    cursor: pointer;
  }
`;

export const ChoosePhotoBox = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  max-width: 1400px;

  > h3 {
    ${({ theme }) => theme.typography.BOLD_60};
    color: ${({ theme }) => theme.color[2]};
    line-height: 100px;
    margin-bottom: 72px;
  }
`;

// pagination
export const PaginationControls = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;

  span {
    ${({ theme }) => theme.typography.BOLD_36};
    font-weight: bold;
    color: ${({ theme }) => theme.color[2]};
  }

  button {
    border: none;
    border-radius: 4px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;

    svg {
      width: 100px;
      height: 100px;
    }

    &:disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }
  }
`;

export const OriginalPhotoSection = styled.div`
  margin-bottom: 30px;
`;

export const AiPhotoSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;

  > div:first-of-type {
    display: flex;
    width: 100%;
    justify-content: space-between;
`;
